<template>
  <span class="icons inline-block" :style="{ width: `${size}` }">

    <svg
      v-if="name === 'grid-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      class="fill-current"
      viewBox="0 0 20 20"
    >
      <path :id="color" d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
    </svg>

    <svg
      v-if="name === 'user-group-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      class="fill-current"
      viewBox="0 0 20 20"
    >
      <path :id="color" d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
    </svg>

    <svg
      v-if="name === 'cog-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'google'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
    >
      <g>
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
        <path fill="none" d="M0 0h48v48H0z" />
      </g>
    </svg>

    <svg
      v-if="name === 'key-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'search-circle'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path d="M9 9a2 2 0 114 0 2 2 0 01-4 0z" />
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'link'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path fill-rule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'download-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'loader-white'"
      :width="size"
      :height="size"
      class="animate-spin text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
      />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>

    <svg
      v-if="name === 'loader'"
      :width="size"
      :height="size"
      class="animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
      />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>

    <svg
      v-if="name === 'office-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'pencil-alt-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="fill-current"
    >
      <path d="M7.24264 17.9967H3V13.754L14.435 2.319C14.8256 1.92848 15.4587 1.92848 15.8492 2.319L18.6777 5.14743C19.0682 5.53795 19.0682 6.17112 18.6777 6.56164L7.24264 17.9967ZM3 19.9967H21V21.9967H3V19.9967Z" />
    </svg>

    <svg
      v-if="name === 'pencil'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" />
    </svg>

    <svg
      v-if="name === 'megaphone'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M13.92 3.845a19.362 19.362 0 0 1-6.3 1.98C6.765 5.942 5.89 6 5 6a4 4 0 0 0-.504 7.969 15.97 15.97 0 0 0 1.271 3.34c.397.771 1.342 1 2.05.59l.867-.5c.726-.419.94-1.32.588-2.02-.166-.331-.315-.666-.448-1.004 1.8.357 3.511.963 5.096 1.78A17.964 17.964 0 0 0 15 10c0-2.162-.381-4.235-1.08-6.155ZM15.243 3.097A19.456 19.456 0 0 1 16.5 10c0 2.43-.445 4.758-1.257 6.904l-.03.077a.75.75 0 0 0 1.401.537 20.903 20.903 0 0 0 1.312-5.745 2 2 0 0 0 0-3.546 20.902 20.902 0 0 0-1.312-5.745.75.75 0 0 0-1.4.537l.029.078Z" />
    </svg>

    <svg
      v-if="name === 'folder'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M3.75 3A1.75 1.75 0 0 0 2 4.75v3.26a3.235 3.235 0 0 1 1.75-.51h12.5c.644 0 1.245.188 1.75.51V6.75A1.75 1.75 0 0 0 16.25 5h-4.836a.25.25 0 0 1-.177-.073L9.823 3.513A1.75 1.75 0 0 0 8.586 3H3.75ZM3.75 9A1.75 1.75 0 0 0 2 10.75v4.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0 0 18 15.25v-4.5A1.75 1.75 0 0 0 16.25 9H3.75Z" />
    </svg>

    <svg
      v-if="name === 'camera'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fill-rule="evenodd" d="M1 8a2 2 0 0 1 2-2h.93a2 2 0 0 0 1.664-.89l.812-1.22A2 2 0 0 1 8.07 3h3.86a2 2 0 0 1 1.664.89l.812 1.22A2 2 0 0 0 16.07 6H17a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8Zm13.5 3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM10 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'user'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z" />
    </svg>

    <svg
      v-if="name === 'building-storefront'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M2.879 7.121A3 3 0 0 0 7.5 6.66a2.997 2.997 0 0 0 2.5 1.34 2.997 2.997 0 0 0 2.5-1.34 3 3 0 1 0 4.622-3.78l-.293-.293A2 2 0 0 0 15.415 2H4.585a2 2 0 0 0-1.414.586l-.292.292a3 3 0 0 0 0 4.243ZM3 9.032a4.507 4.507 0 0 0 4.5-.29A4.48 4.48 0 0 0 10 9.5a4.48 4.48 0 0 0 2.5-.758 4.507 4.507 0 0 0 4.5.29V16.5h.25a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5H3V9.032Z" />
    </svg>

    <svg
      v-if="name === 'document'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M3 3.5A1.5 1.5 0 0 1 4.5 2h6.879a1.5 1.5 0 0 1 1.06.44l4.122 4.12A1.5 1.5 0 0 1 17 7.622V16.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 16.5v-13Z" />
    </svg>

    <svg
      v-if="name === 'briefcase'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fill-rule="evenodd" d="M6 3.75A2.75 2.75 0 0 1 8.75 1h2.5A2.75 2.75 0 0 1 14 3.75v.443c.572.055 1.14.122 1.706.2C17.053 4.582 18 5.75 18 7.07v3.469c0 1.126-.694 2.191-1.83 2.54-1.952.599-4.024.921-6.17.921s-4.219-.322-6.17-.921C2.694 12.73 2 11.665 2 10.539V7.07c0-1.321.947-2.489 2.294-2.676A41.047 41.047 0 0 1 6 4.193V3.75Zm6.5 0v.325a41.622 41.622 0 0 0-5 0V3.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25ZM10 10a1 1 0 0 0-1 1v.01a1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1H10Z" clip-rule="evenodd" />
      <path d="M3 15.055v-.684c.126.053.255.1.39.142 2.092.642 4.313.987 6.61.987 2.297 0 4.518-.345 6.61-.987.135-.041.264-.089.39-.142v.684c0 1.347-.985 2.53-2.363 2.686a41.454 41.454 0 0 1-9.274 0C3.985 17.585 3 16.402 3 15.055Z" />
    </svg>

    <svg
      v-if="name === 'check'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'building-office'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fill-rule="evenodd" d="M4 16.5v-13h-.25a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5H16v13h.25a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5H4Zm3-11a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM11 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'sparkles'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M15.98 1.804a1 1 0 0 0-1.96 0l-.24 1.192a1 1 0 0 1-.784.785l-1.192.238a1 1 0 0 0 0 1.962l1.192.238a1 1 0 0 1 .785.785l.238 1.192a1 1 0 0 0 1.962 0l.238-1.192a1 1 0 0 1 .785-.785l1.192-.238a1 1 0 0 0 0-1.962l-1.192-.238a1 1 0 0 1-.785-.785l-.238-1.192ZM6.949 5.684a1 1 0 0 0-1.898 0l-.683 2.051a1 1 0 0 1-.633.633l-2.051.683a1 1 0 0 0 0 1.898l2.051.684a1 1 0 0 1 .633.632l.683 2.051a1 1 0 0 0 1.898 0l.683-2.051a1 1 0 0 1 .633-.633l2.051-.683a1 1 0 0 0 0-1.898l-2.051-.683a1 1 0 0 1-.633-.633L6.95 5.684ZM13.949 13.684a1 1 0 0 0-1.898 0l-.184.551a1 1 0 0 1-.632.633l-.551.183a1 1 0 0 0 0 1.898l.551.183a1 1 0 0 1 .633.633l.183.551a1 1 0 0 0 1.898 0l.184-.551a1 1 0 0 1 .632-.633l.551-.183a1 1 0 0 0 0-1.898l-.551-.184a1 1 0 0 1-.633-.632l-.183-.551Z" />
    </svg>

    <svg
      v-if="name === 'bowl'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M8 1.5C8 0.947715 7.55228 0.5 7 0.5C6.44772 0.5 6 0.947715 6 1.5V2.5C6 2.50686 6.00042 2.51285 6.00081 2.51843C6.00385 2.56193 6.00516 2.58063 5.79289 2.79289L5.77277 2.81298C5.50599 3.07912 5 3.58391 5 4.5V5.5C5 6.05228 5.44772 6.5 6 6.5C6.55228 6.5 7 6.05228 7 5.5V4.5C7 4.49314 6.99958 4.48715 6.99919 4.48157C6.99615 4.43807 6.99484 4.41937 7.20711 4.20711L7.22723 4.18702C7.49401 3.92088 8 3.41609 8 2.5V1.5ZM2 9C2 8.44771 2.44772 8 3 8H21C21.5523 8 22 8.44772 22 9V10C22 14.1006 19.5318 17.6248 16 19.1679V20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20V19.1679C4.46819 17.6248 2 14.1006 2 10V9ZM18 0.5C18.5523 0.5 19 0.947715 19 1.5V2.5C19 3.41609 18.494 3.92088 18.2272 4.18702L18.2071 4.20711C17.9948 4.41937 17.9962 4.43807 17.9992 4.48157C17.9996 4.48715 18 4.49314 18 4.5V5.5C18 6.05228 17.5523 6.5 17 6.5C16.4477 6.5 16 6.05228 16 5.5V4.5C16 3.58391 16.506 3.07912 16.7728 2.81298L16.7929 2.79289C17.0052 2.58063 17.0038 2.56193 17.0008 2.51843C17.0004 2.51285 17 2.50686 17 2.5V1.5C17 0.947715 17.4477 0.5 18 0.5ZM13.5 1.5C13.5 0.947715 13.0523 0.5 12.5 0.5C11.9477 0.5 11.5 0.947715 11.5 1.5V2.5C11.5 2.50686 11.5004 2.51285 11.5008 2.51843C11.5038 2.56193 11.5052 2.58063 11.2929 2.79289L11.2728 2.81298C11.006 3.07912 10.5 3.58391 10.5 4.5V5.5C10.5 6.05228 10.9477 6.5 11.5 6.5C12.0523 6.5 12.5 6.05228 12.5 5.5V4.5C12.5 4.49314 12.4996 4.48715 12.4992 4.48157C12.4962 4.43807 12.4948 4.41937 12.7071 4.20711L12.7272 4.18702C12.994 3.92088 13.5 3.41609 13.5 2.5V1.5Z" />
    </svg>

    <svg
      v-if="name === 'pause-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
    </svg>
    <svg
      v-if="name === 'play-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'user-circle-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'chevron-right'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'duplicate-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
      <path :id="color" d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
    </svg>

    <svg
      v-if="name === 'document-duplicate-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
      <path :id="color" d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
    </svg>

    <svg
      v-if="name === 'trash-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'plus-circle-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'minus-circle-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'switch-horizontal-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
    </svg>

    <svg
      v-if="name === 'bell-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
    </svg>

    <svg
      v-if="name === 'info-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'database-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
      <path :id="color" d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
      <path :id="color" d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
    </svg>

    <svg
      v-if="name === 'cloud-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z" />
    </svg>

    <svg
      v-if="name === 'star-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>

    <svg
      v-if="name === 'document-text-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'academic-cap'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
    </svg>

    <svg
      v-if="name === 'landing-page'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="fill-current"
    >
      <path d="M20.949 14.8882C20.7346 15.6884 19.9121 16.1633 19.1119 15.9489L3.44528 11.751C3.00205 11.6323 2.69653 11.2271 2.70424 10.7683L2.79514 5.36515L4.24403 5.75338L5.15891 9.10435L10.2542 10.4696L9.88479 2.08844L11.8166 2.60608L14.6269 11.6413L19.8883 13.0511C20.6885 13.2655 21.1634 14.088 20.949 14.8882ZM4.00008 19H20.0001V21H4.00008V19Z" />
    </svg>

    <svg
      v-if="name === 'calendar'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path fill-rule="evenodd" d="M5.75 2a.75.75 0 0 1 .75.75V4h7V2.75a.75.75 0 0 1 1.5 0V4h.25A2.75 2.75 0 0 1 18 6.75v8.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-8.5A2.75 2.75 0 0 1 4.75 4H5V2.75A.75.75 0 0 1 5.75 2Zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75Z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'resume'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="fill-current"
    >
      <path d="M20 2C21.6569 2 23 3.34315 23 5V7H21V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5128 17.386 19.9355 17.8834 19.9933L18 20C18.5128 20 18.9355 19.614 18.9933 19.1166L19 19V4H6C5.48716 4 5.06449 4.38604 5.00673 4.88338L5 5V15H3V5C3 3.34315 4.34315 2 6 2H20Z" />
    </svg>

    <svg
      v-if="name === 'share-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
    </svg>

    <svg
      v-if="name === 'globe-alt-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" fill-rule="evenodd" d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'collection-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
    </svg>

    <svg
      v-if="name === 'card-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      class="fill-current"
    >
      <path :id="color" d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
      <path :id="color" fill-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'close'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M15.6666667,7 L9,7 L9,0.333333333 C9,0.149166667 8.85083333,0 8.66666667,0 L7.33333333,0 C7.14916667,0 7,0.149166667 7,0.333333333 L7,7 L0.333333333,7 C0.149166667,7 0,7.14916667 0,7.33333333 L0,8.66666667 C0,8.85083333 0.149166667,9 0.333333333,9 L7,9 L7,15.6666667 C7,15.8508333 7.14916667,16 7.33333333,16 L8.66666667,16 C8.85083333,16 9,15.8508333 9,15.6666667 L9,9 L15.6666667,9 C15.8508333,9 16,8.85083333 16,8.66666667 L16,7.33333333 C16,7.14916667 15.8508333,7 15.6666667,7 Z"
        transform="translate(8.000000, 8.000000) rotate(45.000000) translate(-8.000000, -8.000000) "
      />
    </svg>

    <svg
      v-if="name === 'rotate-ccw'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      version="1.1"
      class="fill-current"
    >
      <path :id="color" d="M3,9.5935425 L2.96590253,9.59296104 C2.94146125,9.59212763 2.91704986,9.59040321 2.89272126,9.58778943 L3,9.5935425 C2.94728508,9.5935425 2.89552285,9.5894636 2.84501168,9.5816042 C2.82438002,9.57828799 2.8036154,9.57437685 2.78297173,9.56980717 C2.7524728,9.56319361 2.72203882,9.55491948 2.69221749,9.54528268 C2.68703584,9.54352341 2.68176984,9.54177756 2.6765161,9.53998693 C2.65210462,9.53172101 2.6281868,9.52248987 2.60473279,9.512387 C2.57586864,9.50000342 2.54702025,9.48595534 2.5187762,9.47044835 C2.4670062,9.44187457 2.41808469,9.40898838 2.37246466,9.37217471 C2.35826298,9.36081239 2.34434577,9.34892781 2.3306929,9.33660252 C2.31277254,9.32038756 2.29541197,9.30356776 2.27867671,9.28614287 C2.2763736,9.28374509 2.27380445,9.28104084 2.27124694,9.27831909 L2.25836017,9.26435238 C2.23712348,9.24088784 2.21698479,9.21641085 2.19802516,9.19100249 L2.27124694,9.27831909 C2.23795936,9.24289377 2.20775421,9.20568368 2.1806212,9.16701955 C2.16537916,9.14522151 2.15078727,9.12253872 2.13711101,9.09925335 C2.12915731,9.08582902 2.1215475,9.07213898 2.11428517,9.05831805 C2.10422565,9.03906312 2.0948625,9.01976153 2.08611359,9.00012597 C2.07821075,8.98243295 2.07078627,8.96432624 2.06391709,8.94606336 C2.05823342,8.93100713 2.05290496,8.91575297 2.0479406,8.90033541 C2.04104103,8.87873687 2.03493356,8.85725177 2.0295601,8.83562716 C2.02517912,8.81827769 2.02121825,8.80027318 2.01774953,8.78209407 C2.01421854,8.76325678 2.01124142,8.74483196 2.0087815,8.72635473 C2.00804136,8.72108071 2.00736251,8.71562889 2.00672773,8.71016363 L2.00249043,8.66451753 C2.00108003,8.64452793 2.00026831,8.62450756 2.00005439,8.60448546 L2,8.5935425 L2,4.39360717 C2,3.84132242 2.44771525,3.39360717 3,3.39360717 C3.51283584,3.39360717 3.93550716,3.77964736 3.99327227,4.27698605 L4,4.39360717 L4,6.28097528 L5.54144135,4.83388507 C7.84239696,2.53681733 11.3851726,2.03836849 14.2306248,3.61136528 C17.076077,5.18436206 18.5382465,8.44959883 17.8168126,11.6198433 C17.0953788,14.7900878 14.3642592,17.1010825 11.1183362,17.287901 C7.87241328,17.4747195 4.89418848,15.492325 3.81379764,12.4257842 C3.63027586,11.9048829 3.90377603,11.3338351 4.42467737,11.1503133 C4.9455787,10.9667915 5.51662647,11.2402917 5.70014825,11.761193 C6.48453766,13.9875745 8.64679962,15.42684 11.0034168,15.2912053 C13.360034,15.1555707 15.3428917,13.4777336 15.8666698,11.1760608 C16.3904479,8.874388 15.3288781,6.50374854 13.2630122,5.3617155 C11.2683831,4.25906291 8.80179398,4.55839878 7.11087185,6.10038227 L6.93272657,6.27034256 L5.524,7.59297528 L7.19993533,7.5935425 C7.71277117,7.5935425 8.13544249,7.97958269 8.1932076,8.47692137 L8.19993533,8.5935425 C8.19993533,9.10637834 7.81389514,9.52904966 7.31655645,9.58681477 L7.19993533,9.5935425 L3,9.5935425 Z" />
    </svg>

    <svg
      v-if="name === 'more'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M2,6 C3.1045695,6 4,6.8954305 4,8 C4,9.1045695 3.1045695,10 2,10 C0.8954305,10 0,9.1045695 0,8 C0,6.8954305 0.8954305,6 2,6 Z M8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 Z M14,6 C15.1045695,6 16,6.8954305 16,8 C16,9.1045695 15.1045695,10 14,10 C12.8954305,10 12,9.1045695 12,8 C12,6.8954305 12.8954305,6 14,6 Z"
      />
    </svg>

    <svg
      v-if="name === 'plus'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path :id="color" fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'arrow-left'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M7.29289322,0.292893219 C7.68341751,-0.0976310729 8.31658249,-0.0976310729 8.70710678,0.292893219 C9.09763107,0.683417511 9.09763107,1.31658249 8.70710678,1.70710678 L8.70710678,1.70710678 L3.414,7 L15,7 C15.5128358,7 15.9355072,7.38604019 15.9932723,7.88337887 L16,8 C16,8.55228475 15.5522847,9 15,9 L15,9 L3.414,9 L8.70710678,14.2928932 C9.06759074,14.6533772 9.09532028,15.2206082 8.79029539,15.6128994 L8.70710678,15.7071068 C8.31658249,16.0976311 7.68341751,16.0976311 7.29289322,15.7071068 L7.29289322,15.7071068 L0.292893219,8.70710678 L0.292893219,8.70710678 L0.219688767,8.62544899 C0.217372104,8.62256244 0.215071126,8.61966276 0.212785965,8.61675008 C0.207284482,8.60984241 0.201753444,8.60260304 0.196334578,8.59530661 C0.178490093,8.57113069 0.1617187,8.54627495 0.146067433,8.52066019 C0.138606922,8.50861311 0.131498828,8.49639444 0.124671174,8.4840621 C0.11379392,8.46429395 0.103376643,8.4438914 0.0936537803,8.42309915 C0.0856790475,8.4060985 0.0781964242,8.38879565 0.0712254916,8.37133602 C0.0633157362,8.3515792 0.0561224864,8.33179768 0.0495466818,8.31173641 C0.0447287157,8.29685134 0.0400977346,8.28146328 0.0358451423,8.26599297 C0.0298336259,8.24443648 0.0246397952,8.22274608 0.0201651536,8.2007941 C0.0167021706,8.18337526 0.0136280806,8.16594901 0.0110178009,8.14846687 C0.00376118706,8.10036209 0,8.05062028 0,8 L0.00396640833,8.08925007 C0.00189498016,8.06599489 0.000634893312,8.04268105 0.000186147798,8.0193545 L0,8 C0,7.99359377 6.02394912e-05,7.9872016 0.000180182926,7.98082404 C0.000599315847,7.95798023 0.00186560354,7.93433491 0.00396640833,7.91074993 C0.00576611731,7.89015296 0.00811222997,7.87050421 0.0110193427,7.85103878 C0.0136280806,7.83405099 0.0167021706,7.81662474 0.020240071,7.79927424 C0.0246397952,7.77725392 0.0298336259,7.75556352 0.0357209664,7.73416039 C0.0400977346,7.71853672 0.0447287157,7.70314866 0.0497380859,7.68785748 C0.0561224864,7.66820232 0.0633157362,7.6484208 0.0711039637,7.62894148 C0.0781964242,7.61120435 0.0856790475,7.5939015 0.0936733617,7.57677845 C0.103376643,7.5561086 0.11379392,7.53570605 0.12487577,7.51572305 C0.131498828,7.50360556 0.138606922,7.49138689 0.145995454,7.47929125 C0.1617187,7.45372505 0.178490093,7.42886931 0.196313506,7.4048407 C0.225312953,7.36567442 0.257499166,7.32828727 0.292893219,7.29289322 L0.212785965,7.38324992 C0.237668838,7.35153408 0.264426908,7.32135953 0.292893219,7.29289322 Z"
      />
    </svg>

    <svg
      v-if="name === 'check-circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'close-circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'check-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path :id="color" fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'exclamation-solid'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path :id="color" fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'triangle-combo'"
      :width="size"
      :height="size"
      class="fill-current"
      viewBox="0 0 12 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g :id="color">
        <path d="M6.4 10.782l2.33-3.39A.25.25 0 008.526 7h-5.05a.25.25 0 00-.206.392l2.331 3.39c.166.24.48.29.7.109a.525.525 0 00.1-.11zM6.4 1.218l2.33 3.39A.25.25 0 018.526 5h-5.05a.25.25 0 01-.206-.392L5.6 1.218a.473.473 0 01.7-.109.525.525 0 01.1.11z" />
      </g>
    </svg>

    <svg
      v-if="name === 'minus'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path :id="color" fill-rule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'eye'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M8,2 C10.2661661,2 12.2364195,3.08703639 13.8999917,4.86151342 C14.4660328,5.46529052 14.9567154,6.10880872 15.3727098,6.75292911 C15.5528999,7.03193308 15.6933306,7.26977795 15.7935297,7.45223822 L15.8944272,7.6436955 C16.0351909,7.92522299 16.0351909,8.2565952 15.8944272,8.53812269 L15.7935297,8.72957996 C15.6933306,8.91204023 15.5528999,9.1498851 15.3727098,9.42888907 C14.9567154,10.0730095 14.4660328,10.7165277 13.8999917,11.3203048 C12.2364195,13.0947818 10.2661661,14.1818182 8,14.1818182 C5.73383392,14.1818182 3.76358046,13.0947818 2.10000825,11.3203048 C1.53396722,10.7165277 1.04328459,10.0730095 0.627290168,9.42888907 C0.447100104,9.1498851 0.306669414,8.91204023 0.206470325,8.72957996 L0.105572809,8.53812269 C-0.0351909363,8.2565952 -0.0351909363,7.92522299 0.105572809,7.6436955 L0.206470325,7.45223822 C0.306669414,7.26977795 0.447100104,7.03193308 0.627290168,6.75292911 C1.04328459,6.10880872 1.53396722,5.46529052 2.10000825,4.86151342 C3.76358046,3.08703639 5.73383392,2 8,2 Z M8,4 C6.36843881,4 4.87846499,4.82205452 3.55908266,6.22939567 C3.17668821,6.63728309 2.83197348,7.07064528 2.52782705,7.50879411 L2.30736892,7.83797998 L2.14832943,8.09090909 C2.19575319,8.16853748 2.24879291,8.25313986 2.30736892,8.3438382 C2.6619711,8.89289963 3.0810896,9.44256324 3.55908266,9.95242251 C4.87846499,11.3597637 6.36843881,12.1818182 8,12.1818182 C9.63156119,12.1818182 11.121535,11.3597637 12.4409173,9.95242251 C12.9189104,9.44256324 13.3380289,8.89289963 13.6926311,8.3438382 L13.7763329,8.21247241 L13.8516706,8.09090909 L13.6926311,7.83797998 C13.3380289,7.28891855 12.9189104,6.73925494 12.4409173,6.22939567 C11.121535,4.82205452 9.63156119,4 8,4 Z M8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 Z"
      />
    </svg>

    <svg
      v-if="name === 'arrow-right'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M7.29289322,0.292893219 C7.68341751,-0.0976310729 8.31658249,-0.0976310729 8.70710678,0.292893219 C9.09763107,0.683417511 9.09763107,1.31658249 8.70710678,1.70710678 L8.70710678,1.70710678 L3.414,7 L15,7 C15.5128358,7 15.9355072,7.38604019 15.9932723,7.88337887 L16,8 C16,8.55228475 15.5522847,9 15,9 L15,9 L3.414,9 L8.70710678,14.2928932 C9.06759074,14.6533772 9.09532028,15.2206082 8.79029539,15.6128994 L8.70710678,15.7071068 C8.31658249,16.0976311 7.68341751,16.0976311 7.29289322,15.7071068 L7.29289322,15.7071068 L0.292893219,8.70710678 L0.292893219,8.70710678 L0.219688767,8.62544899 C0.217372104,8.62256244 0.215071126,8.61966276 0.212785965,8.61675008 C0.207284482,8.60984241 0.201753444,8.60260304 0.196334578,8.59530661 C0.178490093,8.57113069 0.1617187,8.54627495 0.146067433,8.52066019 C0.138606922,8.50861311 0.131498828,8.49639444 0.124671174,8.4840621 C0.11379392,8.46429395 0.103376643,8.4438914 0.0936537803,8.42309915 C0.0856790475,8.4060985 0.0781964242,8.38879565 0.0712254916,8.37133602 C0.0633157362,8.3515792 0.0561224864,8.33179768 0.0495466818,8.31173641 C0.0447287157,8.29685134 0.0400977346,8.28146328 0.0358451423,8.26599297 C0.0298336259,8.24443648 0.0246397952,8.22274608 0.0201651536,8.2007941 C0.0167021706,8.18337526 0.0136280806,8.16594901 0.0110178009,8.14846687 C0.00376118706,8.10036209 0,8.05062028 0,8 L0.00396640833,8.08925007 C0.00189498016,8.06599489 0.000634893312,8.04268105 0.000186147798,8.0193545 L0,8 C0,7.99359377 6.02394912e-05,7.9872016 0.000180182926,7.98082404 C0.000599315847,7.95798023 0.00186560354,7.93433491 0.00396640833,7.91074993 C0.00576611731,7.89015296 0.00811222997,7.87050421 0.0110193427,7.85103878 C0.0136280806,7.83405099 0.0167021706,7.81662474 0.020240071,7.79927424 C0.0246397952,7.77725392 0.0298336259,7.75556352 0.0357209664,7.73416039 C0.0400977346,7.71853672 0.0447287157,7.70314866 0.0497380859,7.68785748 C0.0561224864,7.66820232 0.0633157362,7.6484208 0.0711039637,7.62894148 C0.0781964242,7.61120435 0.0856790475,7.5939015 0.0936733617,7.57677845 C0.103376643,7.5561086 0.11379392,7.53570605 0.12487577,7.51572305 C0.131498828,7.50360556 0.138606922,7.49138689 0.145995454,7.47929125 C0.1617187,7.45372505 0.178490093,7.42886931 0.196313506,7.4048407 C0.225312953,7.36567442 0.257499166,7.32828727 0.292893219,7.29289322 L0.212785965,7.38324992 C0.237668838,7.35153408 0.264426908,7.32135953 0.292893219,7.29289322 Z"
        transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
      />
    </svg>

    <svg
      v-if="name === 'triangle-alert'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M8,1 C7.18458753,1 6.42695384,1.42203332 6.00179414,2.11551501 L0.324129998,11.4934464 C-0.102942361,12.2249428 -0.105447182,13.1100402 0.309342103,13.8300284 C0.722121996,14.5465288 1.48545461,14.9909267 2.31436594,15 L13.67476,15 C14.5145454,14.9909267 15.277878,14.5465288 15.6906579,13.8300284 C16.1054472,13.1100402 16.1029424,12.2249428 15.6840996,11.5072899 L10.00111,2.12028178 C9.57304616,1.42203332 8.81541247,1 8,1 Z M8.00000001,3 C8.1213399,3 8.2324713,3.06190479 8.29313761,3.16085813 L13.9649935,12.529256 C14.0140896,12.6136355 14.0144278,12.7331336 13.9576739,12.8316466 C13.8989106,12.9336475 13.787139,12.9987188 13.6638859,13.0000591 L2.32524,13.0000591 C2.21286098,12.9987188 2.10108945,12.9336475 2.04232615,12.8316466 C1.98557224,12.7331336 1.98591042,12.6136355 2.04323615,12.5154125 L7.70976653,3.15609136 C7.7675287,3.06190479 7.8786601,3 8.00000001,3 Z M8,10 C8.55228475,10 9,10.4477153 9,11 C9,11.5522847 8.55228475,12 8,12 C7.44771525,12 7,11.5522847 7,11 C7,10.4477153 7.44771525,10 8,10 Z M8,5.10526316 C8.51283584,5.10526316 8.93550716,5.49130335 8.99327227,5.98864203 L9,6.10526316 L9,8.45112782 C9,9.00341257 8.55228475,9.45112782 8,9.45112782 C7.48716416,9.45112782 7.06449284,9.06508763 7.00672773,8.56774894 L7,8.45112782 L7,6.10526316 C7,5.55297841 7.44771525,5.10526316 8,5.10526316 Z"
      />
    </svg>

    <svg
      v-if="name === 'menu'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M15.6666667,12 C15.8508333,12 16,12.1491667 16,12.3333333 L16,12.3333333 L16,13.6666667 C16,13.8508333 15.8508333,14 15.6666667,14 L15.6666667,14 L0.333333333,14 C0.149166667,14 0,13.8508333 0,13.6666667 L0,13.6666667 L0,12.3333333 C0,12.1491667 0.149166667,12 0.333333333,12 L0.333333333,12 Z M15.6666667,7 C15.8508333,7 16,7.14916667 16,7.33333333 L16,7.33333333 L16,8.66666667 C16,8.85083333 15.8508333,9 15.6666667,9 L15.6666667,9 L0.333333333,9 C0.149166667,9 0,8.85083333 0,8.66666667 L0,8.66666667 L0,7.33333333 C0,7.14916667 0.149166667,7 0.333333333,7 L0.333333333,7 Z M15.6666667,2 C15.8508333,2 16,2.14916667 16,2.33333333 L16,2.33333333 L16,3.66666667 C16,3.85083333 15.8508333,4 15.6666667,4 L15.6666667,4 L0.333333333,4 C0.149166667,4 0,3.85083333 0,3.66666667 L0,3.66666667 L0,2.33333333 C0,2.14916667 0.149166667,2 0.333333333,2 L0.333333333,2 Z"
      />
    </svg>

    <svg
      v-if="name === 'refresh'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'copy'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        :id="color"
        d="M13,4.9 C14.6568542,4.9 16,6.24314575 16,7.9 L16,13 C16,14.6568542 14.6568542,16 13,16 L7.9,16 C6.24314575,16 4.9,14.6568542 4.9,13 L4.9,7.9 C4.9,6.24314575 6.24314575,4.9 7.9,4.9 L13,4.9 Z M13,6.9 L7.9,6.9 C7.34771525,6.9 6.9,7.34771525 6.9,7.9 L6.9,13 C6.9,13.5522847 7.34771525,14 7.9,14 L13,14 C13.5522847,14 14,13.5522847 14,13 L14,7.9 C14,7.34771525 13.5522847,6.9 13,6.9 Z M8.7,0 C10.0254834,0 11.1,1.0745166 11.1,2.4 L11.1,2.4 L11.1,3.1 C11.1,3.65228475 10.6522847,4.1 10.1,4.1 C9.54771525,4.1 9.1,3.65228475 9.1,3.1 L9.1,3.1 L9.1,2.4 C9.1,2.1790861 8.9209139,2 8.7,2 L8.7,2 L2.4,2 C2.1790861,2 2,2.1790861 2,2.4 L2,2.4 L2,8.7 C2,8.9209139 2.1790861,9.1 2.4,9.1 L2.4,9.1 L3.1,9.1 C3.65228475,9.1 4.1,9.54771525 4.1,10.1 C4.1,10.6522847 3.65228475,11.1 3.1,11.1 L3.1,11.1 L2.4,11.1 C1.0745166,11.1 0,10.0254834 0,8.7 L0,8.7 L0,2.4 C0,1.0745166 1.0745166,0 2.4,0 L2.4,0 Z"
      />
    </svg>

    <svg
      v-if="name === 'copy-solid'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
      <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
    </svg>
    <svg
      v-if="name === 'image-solid'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'eye-solid'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      version="1.1"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
      <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
    </svg>

    <svg
      v-if="name === 'spinner'"
      :width="size"
      :height="size"
      class="animate-spin mx-px"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
      <path d="M12.2727273,0 L12.0551293,0.00415858315 C9.09536893,0.117479633 6.72727273,2.53254848 6.72727273,5.5 L6.727,7.199 L5,7.2 C4.44771525,7.2 4,7.64771525 4,8.2 L4,11.8 L4.00672773,11.9166211 C4.06449284,12.4139598 4.48716416,12.8 5,12.8 L6.727,12.799 L6.72727273,19 C6.72727273,19.5522847 7.17498798,20 7.72727273,20 L11.3636364,20 L11.4802575,19.9932723 C11.9775962,19.9355072 12.3636364,19.5128358 12.3636364,19 L12.363,12.799 L14.0909091,12.8 C14.5488914,12.8 14.9483407,12.4888823 15.0604728,12.0448393 L15.9695637,8.44483931 L15.9911964,8.33367327 C16.0723061,7.74310839 15.6132251,7.2 15,7.2 L12.363,7.199 L12.363,5.6 L15,5.6 C15.5522847,5.6 16,5.15228475 16,4.6 L16,1 C16,0.44771525 15.5522847,0 15,0 L12.2727273,0 Z M14,2 L14,3.599 L12.2727273,3.6 C11.2206027,3.6 10.3636364,4.44839671 10.3636364,5.5 L10.3636364,8.2 L10.3703641,8.31662113 C10.4281292,8.81395981 10.8508005,9.2 11.3636364,9.2 L13.716,9.2 L13.312,10.799 L11.3636364,10.8 L11.2470152,10.8067277 C10.7496766,10.8644928 10.3636364,11.2871642 10.3636364,11.8 L10.363,18 L8.727,18 L8.72727273,11.8 L8.720545,11.6833789 C8.66277989,11.1860402 8.24010857,10.8 7.72727273,10.8 L6,10.799 L6,9.2 L7.72727273,9.2 C8.27955748,9.2 8.72727273,8.75228475 8.72727273,8.2 L8.72727273,5.5 C8.72727273,3.56926564 10.3123895,2 12.2727273,2 L14,2 Z" />
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    size: {
      default: 16,
    },
    name: {},
    color: {},
    color2: {},
  },
  data() {
    return {}
  },
}
</script>
